<template>
    <div class="party">
        <div class="swiper">
            <swiper :options="swiperOption" v-if="swiperList.length">
                <swiper-slide v-for="item in swiperList" :key="item.id">
                    <img :src="item.image" alt="">
                </swiper-slide>
                <div class="swiper-pagination"  slot="pagination"></div>
            </swiper> 
        </div>
        <div class="content" >
            <h1 class="title" >{{ selectNewsList.name }}</h1>
            <p class="text" v-html="selectNewsList.description" >
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Party',
    data() {
        return {
            swiperList: [],
            swiperOption: {
                observer:true,
                observeParents:true,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass : 'my-bullet',
                    bulletActiveClass: 'my-bullet-active',
                },
                on:{
                    paginationUpdate: (e) =>{
                        this.selectNewsList = this.swiperList[e.realIndex]
                    }
                },
            },
            selectNewsList: '', 
        }
    },
    mounted() {
        this.getPartyList()
    },
    methods: {
        getPartyList(pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: 'd364002cd2de4a1ab14306f5f513da01',
                    pageNo,
                    pageSize,
                    contentType: 'PICTURE'
                }
            }).then(res => {
                if(res.data.code == 0){
                    console.log(res);
                    this.swiperList = res.data.page.list
                }
            }).catch(err => {
                console.log(err.response);
            })
        }
    },
}
</script>

<style scoped>
.party{
    margin-top: .2rem;
    background: #fff;
    overflow: hidden;
}
.swiper{
    width: 6.9rem;
    margin: .3rem auto;
}
.swiper .swiper-slide{
    width: 100%;
    height: 3.3rem;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.swiper .swiper-slide img{
    width: 100%;
}
.swiper >>> .my-bullet{
    background: #333;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 4px;
}
.swiper >>> .my-bullet-active{
    width: 20px;
    border-radius: 3px;
    background: #fff;
    opacity: 1;
}
.box{
    padding: 0 .3rem;
}
.content{
    padding: 0 .2rem;
}
.title{
    font-size: .28rem;
    font-weight: bold;
    text-align: center;
}
.text{
    margin-top: .2rem;
    font-size: .28rem;
    line-height: 1.5;
}
</style>